import { useContext } from "react";
import { RecordContext } from "../../../components/record/Record";
import { RecordsRelated } from "../../../components/recordsRelated/RecordsRelated";
import { IntakeForm } from "../../treatments/intake-form/IntakeForm";

export const SelectIntakeFormForLead = () => {
    const parentContext = useContext(RecordContext);

    const entity = `intake_forms_${parentContext?.item?.client_type}` as
        | "intake_forms_child"
        | "intake_forms_adult";

    return (
        <RecordsRelated
            entity={entity}
            fieldsToQuery=""
            fieldToFilter="lead"
            recordsOptions={{
                relatedRecords: { hideCreationButton: true },
                extraOptions: { sort: "-date_created" },
            }}
            customComponentContent={<IntakeForm />}
        />
    );
};
